import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 px-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-alert_fehler",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-md-8" }
const _hoisted_7 = { class: "col-12 col-md-2" }
const _hoisted_8 = { class: "col-12 col-md-2" }
const _hoisted_9 = {
  key: 0,
  class: "table table-striped my-4 table-fixed"
}
const _hoisted_10 = { class: "thead-dark" }
const _hoisted_11 = { class: "p-0" }
const _hoisted_12 = {
  key: 0,
  class: "icon icon-navigation_pfeil_unten",
  "aria-hidden": "true"
}
const _hoisted_13 = {
  key: 1,
  class: "icon icon-navigation_pfeil_oben",
  "aria-hidden": "true"
}
const _hoisted_14 = {
  key: 2,
  class: "icon icon-filter",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "p-0" }
const _hoisted_16 = {
  key: 0,
  class: "icon icon-navigation_pfeil_unten",
  "aria-hidden": "true"
}
const _hoisted_17 = {
  key: 1,
  class: "icon icon-navigation_pfeil_oben",
  "aria-hidden": "true"
}
const _hoisted_18 = {
  key: 2,
  class: "icon icon-filter",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "p-0" }
const _hoisted_20 = {
  key: 0,
  class: "icon icon-navigation_pfeil_unten",
  "aria-hidden": "true"
}
const _hoisted_21 = {
  key: 1,
  class: "icon icon-navigation_pfeil_oben",
  "aria-hidden": "true"
}
const _hoisted_22 = {
  key: 2,
  class: "icon icon-filter",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "table-width-100" }
const _hoisted_24 = { class: "hide-in-print table-width-100" }
const _hoisted_25 = { class: "d-flex justify-content-center aling-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_link_add_element = _resolveComponent("link-add-element")!
  const _component_control_search = _resolveComponent("control-search")!
  const _component_button_search = _resolveComponent("button-search")!
  const _component_button_reset = _resolveComponent("button-reset")!
  const _component_link_default = _resolveComponent("link-default")!
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.blacklist.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: "/",
      i18nMessage: "common.backToDashboard",
      class: "mt-2 hide-in-print"
    }),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errorLinkTo: "/"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_link_add_element, {
          i18nMessage: "common.blacklist.add",
          to: { name: 'admin-blacklist-add' },
          class: "d-flex justify-content-end mb-2"
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_control_search, {
              i18nLabel: "views.reservations.search",
              modelValue: _ctx.searchTerm,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.loadFromServer()), ["enter"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_button_search, {
              onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadFromServer())),
              labelHidden: true
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.isResettable())
              ? (_openBlock(), _createBlock(_component_button_reset, {
                  key: 0,
                  onClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetTerm())),
                  labelHidden: true,
                  class: "m-0 p-0 btn-to-danger-link-filter"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.blacklist.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
              _createElementVNode("thead", _hoisted_10, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_11, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.doSort('email')), ["prevent"])),
                      class: "btn btn-table-sort"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.blacklist.email')), 1),
                      (_ctx.sortBy ==='email' && _ctx.sortOrder==='asc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                        : _createCommentVNode("", true),
                      (_ctx.sortBy ==='email' && _ctx.sortOrder==='desc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.sortBy !=='email')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.doSort('expiredAt')), ["prevent"])),
                      class: "btn btn-table-sort"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.blacklist.expiredAt')), 1),
                      (_ctx.sortBy ==='expiredAt' && _ctx.sortOrder==='asc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                        : _createCommentVNode("", true),
                      (_ctx.sortBy ==='expiredAt' && _ctx.sortOrder==='desc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                        : _createCommentVNode("", true),
                      (_ctx.sortBy !=='expiredAt')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_19, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.doSort('description')), ["prevent"])),
                      class: "btn btn-table-sort"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.blacklist.description')), 1),
                      (_ctx.sortBy ==='description' && _ctx.sortOrder==='asc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                        : _createCommentVNode("", true),
                      (_ctx.sortBy ==='description' && _ctx.sortOrder==='desc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                        : _createCommentVNode("", true),
                      (_ctx.sortBy !=='description')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('common.blacklist.actions')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blacklist, (blacklistEntry, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(blacklistEntry.email), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(blacklistEntry)), 1),
                    _createElementVNode("td", null, _toDisplayString(blacklistEntry.description), 1),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_link_default, {
                          i18nMessage: "common.blacklist.edit",
                          to: { name: 'admin-blacklist-edit', params: { email: blacklistEntry.email }, query: { 'fromSearch': 'y' } },
                          iconOnly: true,
                          iconClass: "icon-editieren",
                          class: "align-self-center"
                        }, null, 8, ["to"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.blacklist.length < 1)
          ? (_openBlock(), _createBlock(_component_feedback_message, {
              key: 1,
              message: _ctx.$t('common.blacklist.noEntry')
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}